module.exports = __webpack_public_path__ + "static/media/digest1Jill.7ff68149.png";